import { render, staticRenderFns } from "./SofiaContextualMenu.vue?vue&type=template&id=e783e188&lang=pug&"
import script from "./SofiaContextualMenu.vue?vue&type=script&lang=js&"
export * from "./SofiaContextualMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports